/** VurgunBet registration welcome bonus terms (EN) */
export const REGISTRATION_TERMS_TITLE =
  '"TL 100 FREE BET + 300 FREE SPINS FOR REGISTRATION" BONUS TERMS AND CONDITIONS';

export const REGISTRATION_TERMS_HTML = `
<h1>"TL 100 FREE BET + 300 FREE SPINS FOR REGISTRATION" BONUS TERMS AND CONDITIONS</h1>
<p>Participants who registered for the first time on www.vurgunbet.com and completed the verification procedure from 01 September 2025 through 31 December 2026 can receive a bonus in the form of a free bet with a nominal value of TL 100 + 300 free spins</p>
<h2>To receive a Bonus, the following steps must be completed:</h2>
<p><strong>Step 1:</strong> register on www.vurgunbet.com during the bonus promo period.</p>
<p><strong>Step 2:</strong> complete the verification procedure.</p>
<p><strong>Step 3:</strong> make your first deposit into your gaming account in a single payment of at least TL 10 within 120 hours of registration.<br><br>
The bonus size depends on the amount of the initial deposit set by the Organiser:</p>
<table>
<thead>
<tr>
<th style="text-align:center"><strong>Bonus</strong></th>
<th style="text-align:center"><strong>Amount of the first deposit</strong></th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:center">TL 80 free bet + 150 free spins</td>
<td style="text-align:center">from TL 10 to 19.99</td>
</tr>
<tr>
<td style="text-align:center">TL 90 free bet + 200 free spins</td>
<td style="text-align:center">from TL 20 to 49.99</td>
</tr>
<tr>
<td style="text-align:center">TL 100 free bet + 300 free spins</td>
<td style="text-align:center">from TL 50</td>
</tr>
</tbody>
</table>
<p>After the Organiser's conditions are met, the Participant receives a notification about the availability of the bonus in the notification centre. The bonus is accrued within 72 hours from the moment when the conditions are fulfilled. Each Participant can only get 1 (one) Bonus under this promotion.</p>
<p>The free bet must be used within 7 days from the moment of crediting. Free spins must be used within 7 days from the moment of crediting in the games specified by the Organiser.</p>
<p>The Organiser reserves the right to amend, suspend or cancel the promotion at any time. Full terms are available on the website in the Promos section.</p>
`;
